"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeDatatemplates_en_us = void 0;
function backofficeDatatemplates_en_us() {
    return {
        "backoffice.datatemplates.title": "Data Templates",
        "backoffice.datatemplates.applybtn": "Apply Templates"
    };
}
exports.backofficeDatatemplates_en_us = backofficeDatatemplates_en_us;
